<div
  class="balance-pill"
  tabindex="0"
  (click)="onBalanceClicked()"
  (keydown.enter)="onBalanceClicked()"
  [ngStyle]="balancePillStyles | theme"
>
  @if (balance?.icon && balance?.iconPosition === "start") {
    <app-currency-icon [icon]="balance!.icon!" sizeCss="--icon-medium" class="currency-icon" />
  }
  <span> {{ balance?.text }} </span>
  @if (!balance) {
    <ion-spinner name="crescent" />
  }
  @if (balance?.icon && balance?.iconPosition === "end") {
    <app-currency-icon [icon]="balance!.icon!" sizeCss="--icon-medium" class="currency-icon" />
  }
</div>
